import { Fragment } from 'react';

import VDivider from '~/icons/v-divider.svg';
import { IBreadcrumb, ILink } from '~/lib/data-contract';
import { BreadcrumbBack } from '~/shared/components/BreadcrumbBack/BreadcrumbBack';
import { BreadcrumbLink } from '~/shared/components/BreadcrumbLink/BreadcrumbLink';
import { Icon } from '~/shared/components/Icon/Icon';
import { usePage } from '~/templates/pages/hooks/usePage';

import styles from './productDetailsBreadcrumb.module.css';

export type ProductDetailsBreadcrumbProps = {
	itemMainType?: ILink;
	categoryBreadcrumb?: IBreadcrumb;
};

const getBreadcrumbLabel = (breadcrumb: ILink) => (breadcrumb.title ?? breadcrumb.text ?? '').trim();

const hasLabelAndUrl = (item?: ILink | null): item is ILink => {
	if (!item?.url) {
		return false;
	}

	return Boolean(getBreadcrumbLabel(item));
};

export const ProductDetailsBreadcrumb = ({ itemMainType, categoryBreadcrumb }: ProductDetailsBreadcrumbProps) => {
	const currentPage = usePage();

	// Prioritize categoryBreadcrumb if available, otherwise fall back to page breadcrumb
	const breadcrumbItems = categoryBreadcrumb?.items ?? currentPage?.breadcrumb?.items ?? [];
	const itemsToDisplay = breadcrumbItems.filter(hasLabelAndUrl).slice(-2);
	const visibleBreadcrumbs = itemsToDisplay.length ? itemsToDisplay : itemMainType && hasLabelAndUrl(itemMainType) ? [itemMainType] : [];

	return (
		<div
			className={styles.root}
			data-product-details-breadcrumb
		>
			<BreadcrumbBack />
			{visibleBreadcrumbs.map((breadcrumb) => {
				const label = getBreadcrumbLabel(breadcrumb);

				if (!label) {
					return null;
				}

				return (
					<Fragment key={breadcrumb.id ?? breadcrumb.url}>
						<span className={styles.separator}>
							<Icon size="md">
								<VDivider />
							</Icon>
						</span>
						<BreadcrumbLink
							omitIcon
							url={breadcrumb.url}
							text={label}
						/>
					</Fragment>
				);
			})}
		</div>
	);
};
